import {
    Menu,
    List,
    ListItem,
    ListItemButton,
    Typography,
    useTheme,
} from '../../../../../../base-components';
import { IFilterOption } from '../../../../../table.interfaces';

interface Props {
    anchorEl: HTMLElement | null;
    open: boolean;
    onClose: () => void;
    availableFilterTypes: Array<IFilterOption>;
    handleFilterSelect: (filter: IFilterOption) => void;
}

const FiltersMenu = ({
    anchorEl,
    open,
    onClose,
    availableFilterTypes,
    handleFilterSelect,
}: Props) => {
    const theme = useTheme();
    return (
        <Menu anchorEl={anchorEl} open={open} onClose={onClose}>
            <List>
                {availableFilterTypes.map((filter) => (
                    <ListItem
                        key={filter.id}
                        disablePadding
                        sx={{ height: '27px' }}
                    >
                        <ListItemButton
                            onClick={() => handleFilterSelect(filter)}
                            sx={{ height: '27px' }}
                        >
                            <Typography
                                variant="body2"
                                color={theme.palette.grey[600]}
                            >
                                {filter.label}
                            </Typography>
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Menu>
    );
};

export default FiltersMenu;
